import { render, staticRenderFns } from "./orderSteps.vue?vue&type=template&id=31458a90&scoped=true&"
import script from "./orderSteps.vue?vue&type=script&lang=js&"
export * from "./orderSteps.vue?vue&type=script&lang=js&"
import style0 from "./orderSteps.vue?vue&type=style&index=0&id=31458a90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31458a90",
  null
  
)

export default component.exports